export const ptBR = {
    common: {
        save: "Salvar",
        cancel: "Cancelar",
        add: "Adicionar",
        edit: "Editar",
        done: "Concluído",
        retry: "Tentar novamente",
        copy: "Copiar",
        copied: "Copiado",
        dismiss: "Dispensar",
        hide: "Ocultar",
        show: "Mostrar",
        connect: "Conectar",
        disconnect: "Desconectar",
        name: "Nome",
        email: "E-mail",
        role: "Função",
        status: "Status",
        type: "Tipo",
        user: "Usuário",
        optional: "opcional",
    },
    nav: {
        users: "Usuários",
        settings: "Configurações",
        aiProviders: "Provedores de IA",
        auditLog: "Auditoria",
        tasks: "Tarefas",
    },
    saveDock: {
        saving: "Salvando…",
        fixToSave: "Corrija para salvar",
        saveChanges: "Salvar alterações",
        saved: "Salvo",
        noChanges: "Sem alterações",
        unsavedHint: "Alterações não salvas — salva automaticamente em até 15s",
        ariaSave: "Salvar configuração de provedores de IA",
    },
    config: {
        loading: "Carregando configuração do runtime...",
        sectionCredentials: "Credenciais de LLM",
        sectionLegacy: "Campos de provedor legados",
        sectionOauth: "Conexões OAuth",
        sectionOpenrouter: "OpenRouter / Provedor personalizado",
        sectionModelDefaults: "Padrões de modelo",
        sectionAliases: "Aliases de modelo",
        sectionAgent: "Comportamento do agente",
        legacyFields: {
            anthropicOauthToken: "Token OAuth Anthropic",
            anthropicApiKey: "Chave de API Anthropic",
            openaiApiKey: "Chave de API OpenAI",
            googleApiKey: "Chave de API Google",
            xaiApiKey: "Chave de API xAI",
        },
        legacyPresenceHelp: "Somente leitura — a tabela acima é o editor de credenciais. Estes valores permanecem criptografados em repouso como fallback dormente e são substituídos por uma entrada da tabela para o mesmo provedor (entradas migradas exibem um rótulo “migrated: …”).",
        legacyNone: "Nenhum campo de provedor legado armazenado — a tabela acima é o único repositório de credenciais.",
        oauthLoading: "Carregando status do OAuth…",
        oauthHelp: "O OAuth de assinatura usa um fluxo de código manual — a Lexiun nunca vê a sua senha do ChatGPT. Os tokens são armazenados criptografados e renovados centralmente antes de expirar. Desconectar os apaga imediatamente.",
        openrouterLoading: "Carregando status do provedor…",
        configured: "Configurado",
        notConfigured: "Não configurado.",
        openrouterHelp: "Somente leitura — adicione ou edite endpoints OpenRouter / personalizados como linhas na tabela de Credenciais de LLM acima (§8.10). Um blob legado existente continua servindo como fallback dormente; Desconectar o apaga.",
        openrouterDisconnectConfirm: "Desconectar o OpenRouter? Os chats que dependem desta credencial começarão a falhar.",
        openrouterDisconnected: "OpenRouter desconectado.",
        chatProfile: "Perfil de chat",
        resolving: "Resolvendo…",
        resolvesTo: "Resolve para",
        resolvesThinking: "· thinking=",
        resolvesMaxOut: "· max-out=",
        profileHelpA: "Resolve através do catálogo",
        profileHelpB: "da plataforma. O composto",
        profileHelpC: "sobrepõe o nível de raciocínio à política do perfil.",
        budgetPerTask: "Orçamento por tarefa",
        aliasesHelpBeforePrimary: "Mapeie níveis de capacidade + aliases de tarefa personalizados para um provedor/modelo, com uma reserva opcional. Os harnesses + o padrão de chat resolvem através desta tabela; uma indisponibilidade do provedor desce de",
        aliasesHelpPrimary: "Principal",
        aliasesHelpTo: "para",
        aliasesHelpFallback: "Reserva",
        aliasesHelpAfter: "automaticamente. O selo em cada alias mostra para o que ele resolve agora.",
        thinkingLevel: "Nível de raciocínio",
        notSet: "Não definido",
        thinkingLow: "Baixo",
        thinkingMedium: "Médio",
        thinkingHigh: "Alto",
        maxAgentTurns: "Máx. de turnos do agente",
        systemPromptPrefix: "Prefixo do prompt de sistema",
        systemPromptPlaceholder: "Instruções específicas da organização adicionadas antes de cada execução do agente...",
        systemPromptHelp: "O prefixo do prompt de sistema ainda não é aplicado pelo runtime (compatível para o futuro).",
        lastUpdated: "Última atualização: {date}",
        lastUpdatedBy: " por {user}",
        noChangesToSave: "Nenhuma alteração para salvar",
        autoSaved: "Salvo automaticamente. As alterações sincronizam com o runtime em até 60 segundos.",
        configSaved: "Configuração salva. As alterações sincronizam com o runtime em até 60 segundos.",
        validationFailed: "Falha na validação com LLM real: {label}{detail}{latency}. O modelo padrão NÃO foi salvo.",
        previewRequestFailed: "Falha na requisição de prévia",
        blockingCredential: "Credencial {detail}. Preencha ou remova a linha.",
        blockingAlias: "Alias de modelo {detail}. Preencha ou remova a linha.",
        validationCodes: {
            auth: "Falha na autenticação (a credencial está incorreta ou expirou)",
            "model-unknown": "Modelo desconhecido para o provedor",
            quota: "Cota / limite de taxa excedido",
            network: "Erro de rede ao alcançar o provedor",
            schema: "O servidor rejeitou o formato da requisição",
            unknown: "Falha na validação (motivo desconhecido)",
        },
    },
    oauth: {
        openaiCodexDisplayName: "Assinatura OpenAI / ChatGPT",
        connected: "Conectado",
        connectedMsg: "Conectado.",
        disconnectedMsg: "Desconectado.",
        connectionBroken: "Conexão interrompida",
        degraded: "Degradado",
        reconnect: "Reconectar",
        awaitingCode: "Aguardando código de autorização…",
        emptyValidation: "Cole a URL de redirecionamento (ou o código) do provedor.",
        disconnectConfirm: "Desconectar {name}? Os chats existentes que dependem desta credencial começarão a falhar.",
        step1: "1. Abra a página de login abaixo (nova aba), faça login em {name} e autorize.",
        step2: '2. Depois de autorizar, o navegador abre uma página localhost que ou exibe "Authentication successful" ou não carrega ("não é possível acessar esse site") — tanto faz. Copie a URL inteira da barra de endereços (ela contém o code=…).',
        step3: "3. Cole essa URL aqui e clique em Concluir:",
        urlPlaceholder: "cole a URL completa de redirecionamento localhost",
        connecting: "Conectando…",
        complete: "Concluir",
    },
    searchProviders: {
        title: "Provedores de busca",
        help: "Chaves usadas na busca web do concierge. Uma chave definida aqui pertence a esta organização; sem ela, o padrão da plataforma é usado quando disponível.",
        srcOrg: "chave da organização",
        srcPlatform: "padrão da plataforma",
        srcNone: "não configurado",
        disabledNote: "a busca está desativada para esta organização — a chave abaixo é mantida",
    },
    credentials: {
        colId: "ID",
        colProvider: "Provedor",
        colKeySecret: "Chave / Segredo",
        colEndpoint: "Endpoint",
        addCredential: "Adicionar credencial",
        emptyRow: "Nenhuma credencial ainda — adicione uma linha ou use os valores legados somente leitura ainda armazenados abaixo.",
        help: "Esta tabela é o editor de credenciais — uma linha por chave/endpoint; as linhas têm precedência sobre qualquer valor legado somente leitura abaixo para o mesmo provedor. As chaves salvas aparecem como ***MASKED*** — deixe mascarado para manter o valor armazenado. O OAuth de assinatura do ChatGPT é conectado no painel de Conexões OAuth. Salvar substitui a tabela inteira.",
        providerLabels: {
            anthropic: "Anthropic",
            openai: "OpenAI (chave de API)",
            google: "Google",
            xai: "xAI",
            openrouter: "OpenRouter",
            custom: "Personalizado (compatível com OpenAI)",
        },
        ariaId: "id da credencial",
        ariaProvider: "provedor",
        ariaSecret: "segredo da credencial",
        ariaBaseUrl: "url base",
        ariaModels: "modelos",
        idCollision: "Já existe uma credencial com este id",
        renameLocked: "Digite novamente a chave/segredo antes de renomear — um segredo armazenado não pode migrar para um novo id",
        secretPlaceholder: "chave / token",
        maskedHidden: "O valor armazenado permanece oculto",
        baseUrlPlaceholderOpenrouter: "https://openrouter.ai/api/v1 (padrão)",
        baseUrlPlaceholder: "URL base",
        modelsPlaceholder: "ids de modelo (separados por vírgula)",
        deleteCredential: "Excluir credencial",
        validation: {
            missingSecret: "{id} está sem sua chave/segredo",
            secretTooLong: "o segredo de {id} é muito longo (máx. 8192 caracteres)",
            invalidId: '"{id}" não é um id válido (slug em kebab-case)',
            idTooLong: '"{id}" é muito longo (máx. {max} caracteres)',
            kindCustom: '{id}: o provedor "{provider}" usa o tipo "custom"',
            kindApiKey: '{id}: o provedor "{provider}" usa o tipo "api-key"',
            baseUrlRequired: '{id}: o provedor "custom" exige uma URL base (somente o OpenRouter tem um padrão)',
            baseUrlTooLong: "{id}: a URL base é muito longa (máx. 400 caracteres)",
            baseUrlInvalid: "{id}: a URL base não é uma URL válida",
            tooManyModels: "{id}: no máximo 16 ids de modelo",
            modelIdTooLong: '{id}: o id de modelo "{model}…" é muito longo (máx. 200 caracteres)',
        },
    },
    aliases: {
        addCustomAlias: "Adicionar alias personalizado",
        helpBeforeDefault: "Os níveis predefinidos sempre resolvem — reverter um predefinido para",
        helpDefaultWord: "Padrão",
        helpAfterDefault: "usa o catálogo da plataforma. Os aliases personalizados devem ser SHOUTY_SNAKE_CASE (ex.: WRITER, PETITION_DRAFTER). Salvar substitui a tabela inteira.",
        modeDefault: "Padrão",
        modePin: "Fixar",
        modeDelegate: "Delegar",
        modeDefaultTitle: "Resolver via o catálogo da plataforma",
        modePinTitle: "Fixar uma sequência provedor/modelo para esta organização",
        modeDelegateTitle: "Resolver o que outro alias resolver",
        ariaRowMode: "modo da linha",
        ariaAliasName: "nome do alias",
        ariaDelegateTarget: "destino da delegação",
        ariaProvider: "provedor",
        ariaModel: "modelo",
        ariaThinking: "raciocínio",
        nameCollision: "Já existe um alias com este nome",
        revertTitle: "Reverter para o padrão da plataforma",
        deleteAlias: "Excluir alias",
        delegatesTo: "delega para",
        delegateHint: "— resolve o que aquele alias resolver",
        resolvesViaPlatform: "resolve via o catálogo da plataforma",
        outageDescends: "Desce automaticamente em uma indisponibilidade do provedor",
        removeFallback: "Remover reserva",
        addFallback: "Adicionar reserva",
        inherit: "(herdar)",
        modelPlaceholder: "id do modelo",
        modelRequired: "O id do modelo é obrigatório",
        noCredentialTitle: "A organização não tem credencial para este provedor — o salvamento será rejeitado",
        noCredentialSuffix: " (sem credencial)",
        thinkingOverlayTitle: "Sobreposição de esforço de raciocínio",
        rungPrimary: "1 · Principal",
        rungFallback: "2 · Reserva",
        badges: {
            platform: "plataforma",
            primary: "principal",
            fallback: "reserva",
            rescue: "resgate",
            unavailable: "indisponível",
        },
        providerLabels: {
            "openai-codex": "OpenAI Codex (ChatGPT OAuth)",
            openai: "OpenAI (chave de API)",
            anthropic: "Anthropic",
            google: "Google",
            xai: "xAI",
            openrouter: "OpenRouter",
            custom: "Personalizado",
        },
        validation: {
            primaryMissingModel: "{alias} (principal) está sem um id de modelo",
            fallbackMissingModel: "{alias} (reserva) está sem um id de modelo",
        },
    },
    users: {
        allStatuses: "Todos os status",
        statusActive: "Ativo",
        statusProvisioning: "Provisionando",
        statusDeactivated: "Desativado",
        allRoles: "Todas as funções",
        roleOrgAdmin: "Admin da organização",
        roleMember: "Membro",
        addUser: "Adicionar usuário",
        deactivateConfirm: "Desativar {name}?",
        revokeConfirm: "Revogar o convite pendente de {name}? O link deixa de funcionar.",
        acceptConfirm: 'Aceitar o convite de {name} ({email}) em nome dele?\n\nIsto cria uma identidade Clerk com uma senha temporária conhecida e marca o convite como aceito. Destinado a:\n  • contas +clerk_test (sem entrega de e-mail real), ou\n  • um usuário real que perdeu o link do convite.\n\nSe for um usuário real, você DEVE instruí-lo a usar o fluxo "Esqueci minha senha" do Clerk imediatamente para definir a própria senha.',
        failedDeactivate: "Falha ao desativar o usuário",
        failedResend: "Falha ao reenviar o convite",
        failedRevoke: "Falha ao revogar o convite",
        failedAccept: "Falha ao aceitar o convite",
        freshInvitationUrl: "Nova URL de convite para {email}",
        emailDeliveryFailed: "O convite foi criado, mas NÃO pôde ser entregue em {email}. Compartilhe o link abaixo diretamente.",
        emailDeliveryFailedNoUrl: "O e-mail foi atualizado, mas o convite não pôde ser entregue em {email} e nenhum link compartilhável foi retornado. Use Reenviar na linha do usuário para tentar novamente.",
        loadingUsers: "Carregando usuários...",
        colInvitation: "Convite",
        resendTitle: "Reenviar convite",
        resendLabel: "Reenviar",
        revokeTitle: "Revogar convite",
        acceptTitle: "Aceitar o convite em nome do usuário (desbloqueio de admin — o operador deve instruir usuários reais a redefinir a senha pelo fluxo Esqueci minha senha do Clerk)",
        deactivateTitle: "Desativar usuário",
        editTitle: "Editar usuário",
        noUsersFound: "Nenhum usuário encontrado",
    },
    editUser: {
        title: "Editar {name}",
        failedSave: "Falha ao salvar as alterações",
        emailReissueHint: "Alterar este campo revoga o convite pendente e envia um novo para o novo endereço.",
        emailLockedAccepted: "Este usuário já entrou na plataforma, portanto este endereço agora é a credencial de acesso dele e só pode ser alterado no Clerk.",
        emailLockedUnknown: "Este usuário não tem convite pendente, portanto não é possível confirmar o estado de acesso dele por aqui e o endereço permanece inalterado.",
        emailLockedTitle: "O e-mail só pode ser alterado enquanto houver um convite pendente",
        errNotEditable: "O endereço de e-mail deste usuário não pode ser alterado.",
        errReissueFailed: "O endereço foi salvo, mas o convite não pôde ser reenviado. Use Reenviar neste usuário — enviar este formulário novamente não reenviará o convite.",
        errDuplicate: "Outro usuário desta organização já utiliza {email}.",
        emailNotApplied: "O servidor salvou as demais alterações, mas não aplicou o novo e-mail — ele está executando uma versão sem suporte à edição de e-mail. O endereço permanece inalterado.",
    },
    invite: {
        failedCreate: "Falha ao criar o usuário",
        sentTitle: "Convite enviado",
        sentBody1: "Um e-mail de convite do Clerk está sendo enviado para ",
        sentBody2: ". Ele clica no link, define uma senha e faz login normalmente. Precisa do link diretamente (ex.: um endereço ",
        sentBody3: " que não receberá e-mail real)? Use a ação ",
        resend: "Reenviar",
        sentBody4: " na linha dele assim que o provisionamento terminar — ela retorna uma nova URL compartilhável.",
        emailPlaceholder: "E-mail",
        firstNamePlaceholder: "Nome",
        lastNamePlaceholder: "Sobrenome",
    },
    settings: {
        failedLoad: "Falha ao carregar as configurações",
        failedSave: "Falha ao salvar as configurações",
        loading: "Carregando configurações...",
        couldNotLoad: "Não foi possível carregar as configurações",
        title: "Configurações da organização",
        saved: "Configurações salvas",
        maxUsers: "Máx. de usuários",
        tier: "Plano",
        tierFree: "Gratuito",
        tierStarter: "Inicial",
        tierProfessional: "Profissional",
        tierEnterprise: "Empresarial",
        saveSettings: "Salvar configurações",
    },
    audit: {
        failedLoad: "Falha ao carregar os registros de auditoria",
        title: "Auditoria",
        filterPlaceholder: "Filtrar por ação...",
        loading: "Carregando registros de auditoria...",
        colTime: "Horário",
        colUser: "Usuário",
        colAction: "Ação",
        colEntity: "Entidade",
        colDetails: "Detalhes",
        noEntries: "Nenhum registro de auditoria encontrado",
    },
    tasks: {
        title: "Tarefas",
        comingSoon: "Monitoramento de tarefas por organização — em breve",
    },
    badges: {
        status: {
            ACTIVE: "ACTIVE",
            SUSPENDED: "SUSPENDED",
            PROVISIONING: "PROVISIONING",
            DELETED: "DELETED",
            TERMINATED: "TERMINATED",
            DEACTIVATED: "DEACTIVATED",
            DEACTIVATING: "DEACTIVATING",
        },
        tier: {
            free: "free",
            starter: "starter",
            professional: "professional",
            enterprise: "enterprise",
        },
        role: {
            ORG_ADMIN: "ORG_ADMIN",
            MEMBER: "MEMBER",
        },
        storageMode: {
            shared: "compartilhado",
            dedicated: "dedicado",
        },
        storageModeTitle: {
            shared: "Pool compartilhado — os dados da organização ficam em um compartilhamento NFS Premium multi-inquilino com isolamento por subPath aplicado pelo kernel. Custo marginal de armazenamento ~R$0/mês.",
            dedicated: "Compartilhamento dedicado — a organização tem seu próprio compartilhamento NFS Premium com ACL por compartilhamento. Piso de custo de armazenamento ~R$130/mês por organização.",
        },
        storageTitleFallback: "armazenamento: {mode}",
        clientStatus: {
            active: "ativo",
            prospect: "prospecto",
            inactive: "inativo",
            former: "antigo",
        },
        matterStatus: {
            active: "ativo",
            paused: "pausado",
            closed: "encerrado",
        },
        matterType: {
            civil: "cível",
            labor: "trabalhista",
            tax: "tributário",
            contract: "contratual",
            advisory: "consultivo",
            corporate: "societário",
            realestate: "imobiliário",
            compliance: "compliance",
            other: "outro",
        },
        assignmentRole: {
            LEAD: "LEAD",
            HANDLER: "HANDLER",
            CONTRIBUTOR: "CONTRIBUTOR",
            OBSERVER: "OBSERVER",
        },
        invitation: {
            sent: "Enviado",
            accepted: "Aceito",
            revoked: "Revogado",
            expired: "Expirado",
        },
    },
    clients: {
        placeholderPerson: "João da Silva",
        placeholderCompany: "Acme Brasil Ltda.",
        company: "Empresa",
        person: "Pessoa",
        primaryContactUserId: "ID do usuário de contato principal",
        alias: "Identificador de referência (@alias)",
        aliasHelp: "Usado para referenciar este cliente como @identificador. O servidor normaliza o formato e garante que seja único na organização. Deixe vazio para remover.",
        createClient: "Criar cliente",
        loadingClients: "Carregando clientes...",
        colMatters: "Assuntos",
        noClientsYet: "Nenhum cliente ainda",
        aliasTitle: "Identificador do cliente (@alias)",
        selfBadge: "próprio",
        selectClient: "Selecione um cliente...",
        selfSuffix: " (próprio)",
    },
    clientDelete: {
        confirmPhrase: "EU ENTENDO",
        title: "Excluir este cliente permanentemente?",
        cleanBody: "Esta ação é DEFINITIVA e não pode ser desfeita. O registro do cliente e suas esferas vazias serão removidos.",
        impactTitle: "Excluir cliente com casos?",
        impactBody: "Este cliente será excluído DEFINITIVAMENTE. Os casos NÃO serão apagados — casos vinculados: {count} (na lixeira: {binned}). Eles passarão para «Não atribuídos», sem cliente nem esfera.",
        matterCases: "ativos: {live} · na lixeira: {binned}",
        blockedTitle: "Este cliente não pode ser excluído ainda",
        blockedBody: "Casos em formato antigo dependem da pasta deste cliente — casos bloqueando: {count}. Reatribua ou migre esses casos primeiro.",
        blockedAck: "Entendi",
        typeToConfirm: "Digite para confirmar:",
        deleteAction: "Excluir cliente",
    },
    matters: {
        namePlaceholder: "Defesa em litígio de consumo",
        matterType: "Tipo de assunto",
        typeImmutable: "O tipo de assunto é imutável após a criação.",
        typeFixed: "O tipo de assunto é fixo para este fluxo de criação.",
        primaryLeadUserId: "ID do usuário responsável principal",
        createMatter: "Criar assunto",
        loadingMatters: "Carregando assuntos...",
        colCases: "Casos",
        noMattersYet: "Nenhum assunto ainda",
        selectMatter: "Selecione um assunto...",
    },
    assignments: {
        addUserTo: {
            client: "Adicionar usuário ao cliente",
            matter: "Adicionar usuário ao assunto",
            case: "Adicionar usuário ao caso",
        },
        userId: "ID do usuário",
        addAssignment: "Adicionar atribuição",
        loading: "Carregando atribuições...",
        scopeLabels: {
            client: "Atribuições de cliente",
            matter: "Atribuições de assunto",
            case: "Atribuições de caso",
        },
        directSuffix: " — direta",
        revokeTitle: "Revogar atribuição",
        noDirect: "Nenhuma atribuição direta.",
        inheritedTitle: "Herdadas do escopo pai",
        colInheritedFrom: "Herdada de",
        parent: "pai",
    },
    profilePicker: {
        profileDefault: "(padrão do perfil)",
        unset: "(não definido)",
        thinkingLabel: "raciocínio:",
        ariaBaseProfile: "Perfil base",
        ariaThinkingOverlay: "Sobreposição de raciocínio",
    },
};
//# sourceMappingURL=pt-BR.js.map